import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback, Modal } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';
import Camera, { IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

export const Page5Others = ({ errors, touched, values, state, imageChange, fotoSelfieKTP, fotoSpesimen, setFieldValue,onTINSSNMandatoryChange, takePhoto, onSnapPhoto, onAgreePemrek, onHaveAccountsInOtherBank }) => (
    <React.Fragment>

        <Modal isOpen={state.openModalPhoto}>
            <Row>
                <Col md="12">
                    <Camera
                        onTakePhoto={(dataUri) => { onSnapPhoto(dataUri, setFieldValue); }}
                        imageCompression={0}
                        isImageMirror={false}
                        isFullscreen={false}
                    />
                </Col>
            </Row>
        </Modal>

        <FormGroup tag="fieldset">
            <legend>Data Lainnya Yang Dibutuhkan Bank RDN</legend>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Nama Ahli Waris<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="HeirName" bsSize="sm" invalid={errors.HeirName && touched.HeirName} />
                        {errors.HeirName && touched.HeirName ? (
                            <FormFeedback>{errors.HeirName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Hubungan Ahli Waris<span className="text-danger">*</span></Label>
                        <Field component="select" name="HeirRelation"
                                className={errors.HeirRelation && touched.HeirRelation ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            >
                                <option value="">-- Pilih --</option>
                                <option value="Suami">Suami</option>
                                <option value="Istri">Istri</option>
                                <option value="Ayah">Ayah</option>
                                <option value="Ibu">Ibu</option>
                                <option value="Anak">Anak</option>
                                <option value="Sepupu">Sepupu</option>
                            </Field>
                            {errors.HeirRelation && touched.HeirRelation ? (
                                <FormFeedback>{errors.HeirRelation}</FormFeedback>
                            ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Tujuan Investasi<span className="text-danger">*</span></Label>
                        <Field component="select" name="InvestmentObjectiveId"
                            className={errors.InvestmentObjectiveId && touched.InvestmentObjectiveId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.investmentObjectives.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.InvestmentObjectiveId && touched.InvestmentObjectiveId ? (
                            <FormFeedback>{errors.InvstmentObjective}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Kepemilikan Asset<span className="text-danger">*</span></Label>
                        <Field component="select" name="AssetOwnerId"
                        
                            className={errors.AssetOwnerId && touched.AssetOwnerId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/* <option value="">-- Pilih --</option> */}
                            {dataSeed.assetOwnerships.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.AssetOwnerId && touched.AssetOwnerId ? (
                            <FormFeedback>{errors.AssetOwnerId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Penghasilan Per Tahun<span className="text-danger">*</span></Label>
                        <Field component="select" name="IncomePerAnnumBCA"
                            className={errors.IncomePerAnnumBCA && touched.IncomePerAnnumBCA ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.incomePerAnnumBCAs.map((income, i) =>
                                <option key={i} value={income.id}>{income.name}</option>
                            )}
                        </Field>
                        {errors.IncomePerAnnumBCA && touched.IncomePerAnnumBCA ? (
                            <FormFeedback>{errors.IncomePerAnnumBCA}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="2">
                    <FormGroup>
                        <Label>Wajib FATCA<span className="text-danger">*</span></Label>
                        <Field component="select" name="FATCAMandatory"
                        onKeyUp={(e) => onTINSSNMandatoryChange(e, setFieldValue)}
                            className={errors.FATCAMandatory && touched.FATCAMandatory ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.fATCAs.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.FATCAMandatory && touched.FATCAMandatory ? (
                            <FormFeedback>{errors.FATCAMandatory}</FormFeedback>
                        ) : null}
                         <small id="emailHelp" class="form-text text-muted">Hanya diisi apabila memiliki wajib pajak di negara lain</small>
                    </FormGroup>
                </Col>
                {values.FATCAMandatory === "1" ? 
                <Col md="4">
                    <FormGroup>
                        <Label>TIN/SSN</Label>
                        {values.FATCAMandatory === "2"}
                        <Input tag={Field} name="TINSSN" bsSize="sm" type="number"  invalid={errors.TINSSN && touched.TINSSN}
                        disabled={values.FATCAMandatory === "2"}
                        />
                        {errors.TINSSN && touched.TINSSN ? (
                            <FormFeedback>{errors.TINSSN}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                : null }
                <Col md="2">
                    <FormGroup>
                        <Label>Wajib Pajak Negara Lain<span className="text-danger">*</span></Label>
                        <Field component="select" name="TaxpayerOtherContry"
                            className={errors.TaxpayerOtherContry && touched.TaxpayerOtherContry ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.fATCAs.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                    <Label>Perkiraan Transaksi Efek Harian<span className="text-danger">*</span></Label>
                    <Field component="select" name="DailyNormalTransactionId"
                        
                        className={errors.DailyNormalTransactionId && touched.DailyNormalTransactionId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                        {/* <option value="">-- Pilih --</option> */}
                        {dataSeed.dailyNormalTransactions.map((data, index) =>
                            <option value={data.id} key={index}>{data.name}</option>
                        )}
                    </Field>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Lama Tinggal Di Alamat Terakhir (YYYY-MM)<span className="text-danger">*</span></Label>
                        <Field component="input" name="LongStayAtLastAddressYear" type="month"
                            className={errors.LongStayAtLastAddressYear && touched.LongStayAtLastAddressYear ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                        </Field>
                        {errors.LongStayAtLastAddressYear && touched.LongStayAtLastAddressYear ? (
                            <FormFeedback>{errors.LongStayAtLastAddressYear}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Memiliki Rekening/Kartu Kredit Di Bank/Institusi Lain<span className="text-danger">*</span></Label>
                        <Field component="select" name="HaveAccountsInOtherBank"
                        onKeyUp={(e) => onHaveAccountsInOtherBank(e, setFieldValue)}
                            className={errors.HaveAccountsInOtherBank && touched.HaveAccountsInOtherBank ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.HaveAccountsInOtherBank && touched.HaveAccountsInOtherBank ? (
                            <FormFeedback>{errors.HaveAccountsInOtherBank}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Nama Bank/Institusi<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="OtherBankOrInstitutionName" id="OtherBankOrInstitutionName" type="text" bsSize="sm"
                         disabled={values.HaveAccountsInOtherBank !== "1"}
                            invalid={errors.OtherBankOrInstitutionName && touched.OtherBankOrInstitutionName} />
                        {errors.OtherBankOrInstitutionName && touched.OtherBankOrInstitutionName ? (
                            <FormFeedback>{errors.OtherBankOrInstitutionName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Lama Kepemilikan Di Bank/Institusi Lain (YYYY-MM)<span className="text-danger">*</span></Label>
                        <Field component="input" name="LongOwnershipInOtherBankOrInstitutionYear" type="month"
                         disabled={values.HaveAccountsInOtherBank !== "1"}
                            className={errors.LongOwnershipInOtherBankOrInstitutionYear && touched.LongOwnershipInOtherBankOrInstitutionYear ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                        </Field>
                        {errors.LongOwnershipInOtherBankOrInstitutionYear && touched.LongOwnershipInOtherBankOrInstitutionYear ? (
                            <FormFeedback>{errors.LongOwnershipInOtherBankOrInstitutionYear}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Memiliki Hubungan Usaha Dengan Luar Negeri<span className="text-danger">*</span></Label>
                        <Field component="select" name="HaveBusinessRelationsWithOverseas"
                            className={errors.HaveBusinessRelationsWithOverseas && touched.HaveBusinessRelationsWithOverseas ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.HaveBusinessRelationsWithOverseas && touched.HaveBusinessRelationsWithOverseas ? (
                            <FormFeedback>{errors.HaveBusinessRelationsWithOverseas}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Nama Negara Tempat Hubungan Usaha</Label>
                        <Field component="select" name="BusinessRelationsCountryName"
                          disabled={values.HaveBusinessRelationsWithOverseas === "2"}
                            className={errors.BusinessRelationsCountryName && touched.BusinessRelationsCountryName ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.countries.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.BusinessRelationsCountryName && touched.BusinessRelationsCountryName ? (
                            <FormFeedback>{errors.BusinessRelationsCountryName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Warisan<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfInheritance"
                            className={errors.SourceOfInheritance && touched.SourceOfInheritance ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfInheritance && touched.SourceOfInheritance ? (
                            <FormFeedback>{errors.SourceOfInheritance}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Tabungan<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfSavings"
                            className={errors.SourceOfSavings && touched.SourceOfSavings ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfSavings && touched.SourceOfSavings ? (
                            <FormFeedback>{errors.SourceOfSavings}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Hasil Usaha<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfBusiness"
                            className={errors.SourceOfBusiness && touched.SourceOfBusiness ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfBusiness && touched.SourceOfBusiness ? (
                            <FormFeedback>{errors.SourceOfBusiness}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Hibah/Hadiah<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfGrantOrGift"
                            className={errors.SourceOfGrantOrGift && touched.SourceOfGrantOrGift ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfGrantOrGift && touched.SourceOfGrantOrGift ? (
                            <FormFeedback>{errors.SourceOfGrantOrGift}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Gaji<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfSalary"
                            className={errors.SourceOfSalary && touched.SourceOfSalary ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfSalary && touched.SourceOfSalary ? (
                            <FormFeedback>{errors.SourceOfSalary}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Lainnya<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="SourceOfOther" id="SourceOfOther" type="text" bsSize="sm"
                        className={errors.SourceOfOther && touched.SourceOfOther ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}/>
                        {errors.SourceOfOther && touched.SourceOfOther ? (
                            <FormFeedback>{errors.SourceOfOther}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="2"></Col>
                <Col md="6">
                    {/* <FormGroup>
                        <Label className="form-check-input" for="sayasetuju">Saya Menyetuji Ketentuan Pembukaan Rekening<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="sayasetuju" id="sayasetuju" type="checkbox" onClick={(e) => onAgreePemrek(e, setFieldValue)}
                            invalid={errors.AgreeTermsPemrek && touched.AgreeTermsPemrek} />
                        {errors.AgreeTermsPemrek && touched.AgreeTermsPemrek ? (
                            <FormFeedback>{errors.AgreeTermsPemrek}</FormFeedback>
                        ) : null}
                    </FormGroup> */}
                </Col>
            </Row>
        </FormGroup>
    </React.Fragment>
)



// WEBPACK FOOTER //
// ./src/components/Page5Others.js